module.exports = __webpack_public_path__ + "img/dsu-min.a998c43e.jpeg";